module.exports = __webpack_public_path__ + "media/greetings.3a6961c8.mp3";